'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isArray = require('../compat/predicate/isArray.js');
var isPlainObject = require('../predicate/isPlainObject.js');
var camelCase = require('../string/camelCase.js');
function toCamelCaseKeys(obj) {
    if (isArray.isArray(obj)) {
        return obj.map(function(item) {
            return toCamelCaseKeys(item);
        });
    }
    if (isPlainObject.isPlainObject(obj)) {
        var result = {};
        var keys = Object.keys(obj);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var camelKey = camelCase.camelCase(key);
            var convertedValue = toCamelCaseKeys(obj[key]);
            result[camelKey] = convertedValue;
        }
        return result;
    }
    return obj;
}
exports.toCamelCaseKeys = toCamelCaseKeys;
